import { ReactNode, ElementType, CSSProperties } from "react";
import { useReveal } from "@/hooks/use-reveal";
import { cn } from "@/lib/utils";

type RevealProps = {
  children: ReactNode;
  as?: ElementType;
  className?: string;
  delay?: number;
  y?: number;
};

export function Reveal({ children, as: Tag = "div", className, delay = 0, y = 24 }: RevealProps) {
  const { ref, visible } = useReveal<HTMLElement>();
  const style: CSSProperties = {
    transitionDelay: `${delay}ms`,
    transform: visible ? "translateY(0)" : `translateY(${y}px)`,
    opacity: visible ? 1 : 0,
  };
  return (
    <Tag
      ref={ref as never}
      style={style}
      className={cn("transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] will-change-transform", className)}
    >
      {children}
    </Tag>
  );
}
